import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import equal from "fast-deep-equal/es6/react";
import Chart from "chart.js";
import { PdApiActions, pdApiActions } from "../../actions/pdApiActions";
import classes from "./Chart.module.scss";

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
};

type OwnProps = {
  option: Api.OptionsGetChartData;
  datasets: Api.SeriesDataset[];
  title?: string;
  height?: string;
  width?: string;
  displayYAxis?: boolean;
};

export type LanguageCoverageChartProps = DispatchProps & OwnProps;

type OwnState = {
  allSelected: boolean;
};

class LanguageCoverageChart extends React.Component<LanguageCoverageChartProps, OwnState> {
  public static defaultProps = {
    height: "425px"
  };
  chartRef: React.RefObject<HTMLCanvasElement> = React.createRef<HTMLCanvasElement>();
  myChart?: Chart = undefined;

  state = {
    allSelected: true
  };

  componentDidMount() {
    this.buildChart();
  }

  shouldComponentUpdate(nextProps: LanguageCoverageChartProps) {
    return !equal(this.props.datasets, nextProps.datasets);
  }

  componentDidUpdate() {
    this.buildChart();
  }

  buildChart() {
    const { datasets } = this.props;

    const myChartRef = this.chartRef.current?.getContext("2d");

    if (this.myChart) {
      this.myChart.destroy();
    }

    if (myChartRef) {
      this.myChart = new Chart(myChartRef, {
        type: "bar",
        data: {
          datasets: [
            {
              data: datasets.map(item => item.value),
              backgroundColor: "#0071B9",
              barPercentage: 3,
              categoryPercentage: 0.2
            }
          ],
          labels: datasets.map(item => item.label)
        },
        options: {
          events: ["mousemove", "mouseout", "touchstart", "touchmove"],
          maintainAspectRatio: false,
          animation: {
            duration: 500
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: { display: false },
                ticks: {
                  autoSkip: false,
                  maxRotation: 0,
                  minRotation: 0,
                  fontSize: 12,
                  fontFamily: "KONE",
                  fontColor: "#000",
                  fontStyle: "500"
                }
              }
            ],
            yAxes: [
              {
                display: this.props.displayYAxis,
                ticks: {
                  stepSize: 50,
                  suggestedMin: 0,
                  suggestedMax: 100,
                  beginAtZero: true,
                  callback: function(value: number) {
                    return value + "%";
                  }
                },
                gridLines: { display: false }
              }
            ]
          }
        }
      });
    }
  }

  render() {
    return (
      <div>
        <div className={classes.chartTitle}>{this.props.title}</div>
        <div className={classes.chartContainer}>
          <canvas 
            id="languageCoverageChart"
            height={this.props.height} 
            width={this.props.width} 
            ref={this.chartRef} />
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch: Dispatch<PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(null, mapDispatchToProps)(LanguageCoverageChart);
